<div class="container">
  <ghs-header [standalone]="true"></ghs-header>

  <div class="menu">
    <label>
      <span [ghs-label]="'settings.edition'"></span>
      <select [(ngModel)]="edition" (change)="update(); updateQueryParams()">
        <option *ngFor="let edition of gameManager.editions(true)" [value]="edition">
          <span [ghs-label]="'data.edition.' + edition"></span>
        </option>
      </select>
    </label>
    <label>
      <span [ghs-label]="'settings.character'"></span>
      <select [(ngModel)]="characterName" (change)="update(); updateQueryParams()" multiple>
        <option *ngFor="let character of characters" [value]="character.name">
          <span [ghs-label]="'data.character.' + character.edition + '.' + character.name"></span>
        </option>
      </select>
    </label>
  </div>

  <div class="characters">
    <ng-container *ngFor="let character of filteredCharacters">
      <div class="character" *ngIf="!!character && character.attackModifierDeck.cards.length > 0">
        <h1><span [ghs-label]="'data.character.' + character.edition + '.' + character.name"></span> [{{character.attackModifierDeck.cards.length}}]
        </h1>
        <ghs-attackmodifier [attackModifier]="attackModifier" [flipped]="true"
          [characterIcon]="gameManager.characterManager.characterIcon(character)"
          *ngFor="let attackModifier of character.attackModifierDeck.cards"
          [newStyle]="settingsManager.settings.fhStyle || gameManager.newAmStyle(character.edition)"></ghs-attackmodifier>
      </div>
    </ng-container>
  </div>
</div>